
import { supabase } from "@/integrations/supabase/client";
import { Tables } from "@/integrations/supabase/types";
import { AgentVariable } from "@/types/admin";

// Fetch variables for an agent
export const fetchAgentVariables = async (agentId: string): Promise<AgentVariable[]> => {
  const { data, error } = await supabase
    .from("agent_variables")
    .select("*")
    .eq("agent_id", agentId)
    .order("key");

  if (error) throw error;
  return data || [];
};

// Create a new variable
export const createAgentVariable = async (variable: {
  agent_id: string;
  key: string;
  value: string;
  source: string;
}): Promise<AgentVariable> => {
  const { data, error } = await supabase
    .from("agent_variables")
    .insert(variable)
    .select()
    .single();

  if (error) throw error;
  return data;
};

// Update a variable
export const updateAgentVariable = async (id: string, variable: { value?: string; source?: string }): Promise<AgentVariable> => {
  const { data, error } = await supabase
    .from("agent_variables")
    .update(variable)
    .eq("id", id)
    .select()
    .single();

  if (error) throw error;
  return data;
};

// Delete a variable
export const deleteAgentVariable = async (id: string): Promise<void> => {
  const { error } = await supabase
    .from("agent_variables")
    .delete()
    .eq("id", id);

  if (error) throw error;
};

// Upsert multiple variables at once
export const upsertAgentVariables = async (
  agentId: string, 
  variables: Array<{
    key: string;
    value: string;
    source: string;
  }>
): Promise<AgentVariable[]> => {
  const variablesWithAgentId = variables.map(variable => ({
    ...variable,
    agent_id: agentId
  }));

  const { data, error } = await supabase
    .from("agent_variables")
    .upsert(variablesWithAgentId, { 
      onConflict: 'agent_id,key',
      ignoreDuplicates: false
    })
    .select();

  if (error) throw error;
  return data || [];
};
